import { useRef, useState, useEffect, useCallback } from "react";
import Controller from "./ControllerEnum";
import AudioControllers from "./AudioControllers";

export default function AudioController({ lullabyPlayer }) {
  const { status, stop, play } = lullabyPlayer;
  const [currentController, setCurrentController] = useState(
    Controller.PLAY_BUTTON
  );
  const currentElementRef = useRef(Controller.PLAY_BUTTON);
  const statusRef = useRef(status);
  const finishedLoadingRef = useRef(true);
  const wasStuckRef = useRef(false);

  useEffect(() => {
    if (status === "PLAYING") {
      statusRef.current = status;
      if (wasStuckRef.current) {
        wasStuckRef.current = false;
        setCurrentController(Controller.LOADING_INTO_STOP);
        currentElementRef.current = Controller.LOADING_INTO_STOP;
      }
      if (currentController !== Controller.STOP_BUTTON) {
        if (
          currentElementRef.current !== Controller.LOADING_INTO_STOP &&
          finishedLoadingRef.current
        ) {
          setCurrentController(Controller.WITHOUT_LOADING_INTO_STOP);
        }
      }
    }
    if (status === "RESTING") {
      finishedLoadingRef.current = true;
      currentElementRef.current = Controller.PLAY_BUTTON;
      if (currentController !== Controller.PLAY_BUTTON) {
        setCurrentController(Controller.INTO_PLAY);
      }
    }
    if (status === "LOADING") {
      finishedLoadingRef.current = false;
      statusRef.current = status;
      currentElementRef.current = Controller.LOADING_INTO_STOP;
    }
  }, [status, currentController]);

  const checkStatus = useCallback(() => {
    if (statusRef.current === "LOADING") {
      wasStuckRef.current = true;
      setCurrentController(Controller.STUCK_ANIMATION);
    } else {
      setCurrentController(Controller.LOADING_INTO_STOP);
      finishedLoadingRef.current = true;
    }
  }, []);

  const onPlay = useCallback(() => {
    setCurrentController(Controller.INITIAL_LOAD);
    play();
  }, [play]);

  const onStop = useCallback(() => {
    setCurrentController(Controller.INTO_PLAY);
    stop();
  }, [stop]);

  const withoutLoadingIntoStopCompleteHandler = useCallback(() => {
    setCurrentController(Controller.STOP_BUTTON);
  }, []);

  const initialLoadCompeleteHandler = useCallback(() => {
    finishedLoadingRef.current = true;
    checkStatus();
  }, [checkStatus]);

  const loadingIntoStopCompleteHandler = useCallback(() => {
    setCurrentController(Controller.STOP_BUTTON);
  }, []);

  const intoPlayCompleteHandler = useCallback(() => {
    setCurrentController(Controller.PLAY_BUTTON);
  }, []);

  return (
    <AudioControllers
      currentController={currentController}
      onPlay={onPlay}
      onStop={onStop}
      withoutLoadingIntoStopCompleteHandler={
        withoutLoadingIntoStopCompleteHandler
      }
      initialLoadCompeleteHandler={initialLoadCompeleteHandler}
      loadingIntoStopCompleteHandler={loadingIntoStopCompleteHandler}
      intoPlayCompleteHandler={intoPlayCompleteHandler}
    />
  );
}
